import axios from "axios";
import { store } from "./Redux/store";
import { authSuccess, emptyUser } from "./Redux/slices/AuthSlice";

// ✅ Remove trailing slash
const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000/api";

// ── Public instance ────────────────────────────────────────────────────────────
export const publicRequest = axios.create({
  baseURL: BASE_URL,
});

// ── Private instance ────────────────────────────────────────────────────────────
export const userRequest = axios.create({
  baseURL: BASE_URL,
});

// Attach access token to every request
userRequest.interceptors.request.use((config) => {
  const state = store.getState();
  const token = state.auth?.currentUser?.token;
  if (token) {
    config.headers["Authorization"] = token.startsWith("Bearer ")
      ? token
      : `Bearer ${token}`;
  }

  // Also attach refresh token so the server can silently re-issue access token
  const refreshToken = state.auth?.currentUser?.refreshToken;
  if (refreshToken) {
    config.headers["x-refresh-token"] = refreshToken;
  }

  return config;
});

// If the server issued a new access token, silently swap it in Redux + persist
userRequest.interceptors.response.use(
  (response) => {
    const newToken = response.headers["x-new-access-token"];
    if (newToken) {
      const state = store.getState();
      const currentUser = state.auth?.currentUser;
      // Patch only the token, keep everything else (worker info, refreshToken…)
      store.dispatch(
        authSuccess({
          ...currentUser,
          token: "Bearer " + newToken,
        })
      );
    }
    return response;
  },
  (error) => {
    // 401 means refresh token is also expired → force logout
    if (error.response?.status === 401) {
      store.dispatch(emptyUser());
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);